import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as Actions from "../../../../store/modules/scholars";
import * as FActions from "../../../../store/modules/footer";
import {PropTypes} from "prop-types";
import {
	getNumberFormat,
	getObjectLength,
	getSelectFormat,
	objectToQueryString,
	pushUrl
} from "../../../../utils/functions";
import {BASE_PATH, SCHOLAR_FACET_ADMIN_ORDER, SCHOLAR_FACET_NAME, STATUS_NAME} from "../../../../wpconfig";
import SelectBox from "../../../etc/SelectBox";
import * as func from "../../../../utils/functions";

class ScholarFacet extends Component {
	constructor(props) {
		super(props);

		this.state = {
			url : 'wp-admin/admin.php?page=scholar&',
			action : 'admin/scholars'
		}
	}

	argsInputTextEvnet = (event) => {
		const {dataActions} = this.props;
		let param = this.props.param;
		param[event.target.name] = event.target.value;
		dataActions.setScholars({"param": param});

		if (event.key === "Enter") {
			setTimeout(() => {
				this.search()
			}, 0);
		}
	}

	facetChangeEvent = (event) => {
		if (event.target.type === "checkbox") {
			let param = this.props.param;
			if (event.target.checked) {
				if (param[event.target.name].indexOf(event.target.value) < 0) {
					param[event.target.name].push(event.target.value);
				}
			} else {
				if (param[event.target.name].indexOf(event.target.value) > -1) {
					param[event.target.name].splice(param[event.target.name].indexOf(event.target.value), 1);
				}
			}
			const {dataActions} = this.props;
			dataActions.setScholars({"param": param});

			setTimeout(() => {
				func.getData(this.state.action, this.props.param).then((response) => {
					this.props.dataActions.setScholars(response);

					const url = objectToQueryString(this.props.param);
					pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
				});
			}, 0);
		} else if (event.target.type === "button") {
			let param = this.props.param;
			if (param[event.target.name].indexOf(event.target.value) < 0) {
				param[event.target.name].push(event.target.value);
			}
			const {dataActions} = this.props;
			dataActions.setScholars({"param": param});

			setTimeout(() => {
				func.getData(this.state.action, this.props.param).then((response) => {
					this.props.dataActions.setScholars(response);

					const url = objectToQueryString(this.props.param);
					pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
				});
			}, 0);
		} else {
			const {dataActions} = this.props;
			let param = this.props.param;
			param[event.target.name] = event.target.value;
			dataActions.setScholars({"param": param});
		}
	}

	facetChangeEventOnly = (event) => {
		if (event.target.type === "checkbox") {
			let param = this.props.param;
			if (event.target.checked) {
				param[event.target.name] = event.target.value;
			} else {
				param[event.target.name] = '';
			}
			const {dataActions} = this.props;
			dataActions.setScholars({"param": param});

			func.getData(this.state.action, param).then((response) => {
				this.props.dataActions.setScholars(response);

				const url = objectToQueryString(param);
				pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
			});
		}
	}

	facetReset = (event) => {
		var param = this.props.param;
		Object.keys(this.props.param).map((key, i) => {
			if (!param[key] || param[key].length <= 0)
				return;
			if (key === 'records_per_page' || key === 'order' || key === 'orderby') {
			} else if (key === 'current_page') {
				param[key] = 1;
			} else if (Array.isArray(param[key])) {
				param[key] = [];
			} else {
				param[key] = "";
			}
		});

		const {dataActions} = this.props;
		dataActions.setScholars({"param": param});
		func.getData(this.state.action, this.props.param).then((response) => {
			this.props.dataActions.setScholars(response);

			pushUrl('검색', BASE_PATH + this.state.url, null);
		});
	}

	search = (event) => {
		func.getData(this.state.action, this.props.param).then((response) => {
			this.props.dataActions.setScholars(response);

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
		});
	}

	tabAction = (event) => {
		event.target.parentNode.classList.toggle('active');
	}

	morePopup = (type) => {
		this.props.fDataActions.setFooter({
			'isPopup1': this.props.isPopup1 === 'true' ? 'false' : 'true',
			'type': type,
			'part' : 'scholars'
		});
	}

	setDate = (date) => {
		event.preventDefault();

		let s, e
		const d = new Date();
		d.setDate(d.getDate()+1)
		e = d
		let in_date_start, in_date_end
		// console.log(d)

		if (date === '1d') {
			s = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1)
		} else if (date === '1w') {
			s = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 7)
		} else if (date === '1m') {
			s = new Date(d.getFullYear(), d.getMonth() - 1, d.getDate())
		} else if (date === '1y') {
			s = new Date(d.getFullYear() - 1, d.getMonth(), d.getDate())
		}

		in_date_start = s.getFullYear() + '-' + ('0' + (s.getMonth() + 1)).slice(-2) + '-' + ('0' + (s.getDate())).slice(-2)
		in_date_end = e.getFullYear() + '-' + ('0' + (e.getMonth() + 1)).slice(-2) + '-' + ('0' + (e.getDate())).slice(-2)

		var param = this.props.param;
		param.in_date_start = in_date_start
		param.in_date_end = in_date_end
		this.props.dataActions.setScholars({"param": param});

		func.getData(this.state.action, this.props.param).then((response) => {
			this.props.dataActions.setScholars(response);

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, null);
		});
	}

	render() {
		const facets = getObjectLength(this.props.facet) > 0 ? SCHOLAR_FACET_ADMIN_ORDER : [];
		const param = this.props.param;
		return (
			<>
				<div className="d-flex justify-content-between align-items-center">
				<h6 className="con-title">패싯 검색</h6>
					<div className="d-flex">
						<button type="button" className="btn-search-ui ml-2" onClick={this.facetReset}>
							<span className="icon icon-size-24 icon-refresh-white" />
						</button>
					</div>
				</div>
				<div className="form-group mt-3">
					<label htmlFor="within_ks" className="form-label"><strong>결과내 검색</strong></label>
					<div className="input-group">
						<input type="text" name="sub_ks" value={param.sub_ks} onChange={this.argsInputTextEvnet}
						       className="form-control" autoComplete="off"/>
						<button className="btn btn-sm btn-primary" type="button" onClick={this.search}>검색</button>
					</div>
				</div>
				<div className="mt-3 pt-2 border-top mb-4">
					<label htmlFor="within_ks" className="form-label"><strong>날짜 검색</strong></label>
					<div className="form-row mb-1">
						<select className="form-control" name="date_type"
						        value={param.date_type} onChange={this.facetChangeEvent}>
							<option value="input_date">입력(생성)일</option>
							<option value="modified_date">최종수정일</option>
						</select>
					</div>
					<div className="form-row">
						<div className="col pl-0">
							<input type="text" name="in_date_start" value={param.in_date_start} 
										 onChange={this.argsInputTextEvnet}
							       className="form-control" autoComplete="off"/>
						</div>
						<div className="col-1">
							<span className="text-center align-middle">~</span>
						</div>
						<div className="col pr-0">
							<input type="text" name="in_date_end" value={param.in_date_end} onChange={this.argsInputTextEvnet}
							       className="form-control" autoComplete="off"/>
						</div>
					</div>
					<div className="form-row mt-1 d-flex">
						<div className="p-0 pt-1">
							<span className="badge badge-secondary mr-1 p-1" onClick={() => this.setDate('1d')}>1일</span>
							<span className="badge badge-secondary mr-1 p-1" onClick={() => this.setDate('1w')}>1주일</span>
							<span className="badge badge-secondary mr-1 p-1" onClick={() => this.setDate('1m')}>1달</span>
							<span className="badge badge-secondary p-1" onClick={() => this.setDate('1y')}>1년</span>
						</div>
						<a href="#" className="btn btn-outline-primary btn-sm ml-auto" onClick={this.search}>검색</a>
					</div>
				</div>
				{/*<div className="mt-3 pt-2 border-top">*/}
				{/*	<label htmlFor="worker" className="form-label"><strong>작업자 검색</strong></label>*/}
				{/*	<div className="input-group">*/}
				{/*		<input type="text" name="worker" defaultValue={param.worker} onKeyUp={this.argsInputTextEvnet}*/}
				{/*		       className="form-control" autoComplete="off"/>*/}
				{/*		<button className="btn btn-sm btn-primary" type="button" id="search_worker">검색</button>*/}
				{/*	</div>*/}
				{/*	<div className="form-row mt-1">*/}
				{/*		<a href="#" className="btn btn-outline-primary btn-sm ml-auto" onClick={this.search}>범위 재설정</a>*/}
				{/*	</div>*/}
				{/*</div>*/}
				{this.props.facet && getObjectLength(this.props.facet) > 0 ?
					facets.map((fa, i) => {
						const facet = this.props.facet[fa];
						if (!facet)
							return;
						if(facet.result.length <= 0)
							return;

						if (fa === 'dept')
							facet.result = getSelectFormat(facet.result);
						return (
							<div key={i}>
								{(fa === 'dept') ?
									<div className="form-side-search">
										<div className="form-title">학과 선택</div>
										<SelectBox
											name={fa}
											title="선택해주세요"
											isMulti
											onAdd={this.facetChangeEvent}
											onRemove={this.facetChangeEvent}
											OptionData={facet.result}
										/>
									</div>
									:
									<div className="form-side-search mt-3">
										<div className="form-tree-item active" onClick={this.tabAction}>
											<button type="button" className="btn-tree-nav">{SCHOLAR_FACET_NAME[fa]}</button>
											<div className="detail-tree-item mt-1">
												<div className="vertical-checkbox-list">
													<div className="checkbox-group">
														<div className="checkbox-group-cell">
															{facet.result.length > 0 && facet.result.map((item, index) => {
																if ((fa !== 'registered_db_name' && fa !== 'journal_ranking' && fa !== 'worker_name') && index >= 5)
																	return;

																if (!item.title)
																	return;

																item.value = fa === 'registered_db_name' ? item.title.toUpperCase() : item.title

																let title = fa === 'scholar_status' ? STATUS_NAME[item.title] : item.title

																const checked = this.props.param[fa].includes(item.title);

																return (
																	<React.Fragment key={index}>
																		<div className="checkbox-group-cell" key={index}>
																			<div className="custom-control custom-checkbox">
																				{fa === 'registered_db_name' || fa === 'worker_name' ?
																					<input id={fa + '_' + index} name={fa} type="checkbox"
																					       className="custom-control-input"
																					       checked={checked} onChange={this.facetChangeEventOnly}
																					       value={item.value}/>
																					:
																					<input id={fa + '_' + index} name={fa} type="checkbox"
																					       className="custom-control-input"
																					       checked={checked} onChange={this.facetChangeEvent} value={item.value}/>
																				}
																				<label className="custom-control-label"
																				       htmlFor={fa + '_' + index}>{title} ({getNumberFormat(item.count)})</label>
																			</div>
																		</div>
																	</React.Fragment>
																)
															})}
														</div>
													</div>
													{(fa !== 'registered_db_name' && facet.result.length > 5) &&
													<div className="checkbox-more">
														<button type="button" className="btn-checkbox-more" onClick={() => this.morePopup(fa)}>
															<span className="icon icon-size-24 icon-plus-black mr-2 align-top"/>More
														</button>
													</div>
													}
												</div>
											</div>
										</div>
									</div>
								}
							</div>
						)
					})
					: ''
				}
			</>
		)
	}
}

export default connect(
	(state) => ({
		totalRecords: state.scholars.totalRecords ? state.scholars.totalRecords : 0,
		facet: state.scholars.facet ? state.scholars.facet : {},
		param: state.scholars.param ? state.scholars.param : {},
		isPopup1: state.scholars.isPopup1 ? state.scholars.isPopup1 : false,
		// args: state.scholars.args ? state.scholars.args : {},
		// facet: state.scholars.facet ? state.scholars.facet : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(ScholarFacet)

ScholarFacet.propTypes = {
	args: PropTypes.object,
	facet: PropTypes.object,
};
